import React, {useEffect, useState} from 'react';

// The map (Google Maps, reproject/proj4 and the layers) is only needed on the map screen,
// so it is split into its own chunk and loaded in the browser after mount.
// The server and the hydrating client both render the empty placeholder, so the markup matches.
// (React.lazy is not used because ReactDOMServer in React 16 does not support Suspense.)
export default function LazyMyMap() {
    const [MyMap, setMyMap] = useState(null);

    useEffect(() => {
        let cancelled = false;
        import(/* webpackChunkName: "map" */ './MyMap')
            .then(module => {
                if (!cancelled) {
                    setMyMap(() => module.default);
                }
            })
            .catch(error => console.log(error));
        return () => {
            cancelled = true;
        };
    }, []);

    if (!MyMap) {
        return <div style={{ flex: 1, width: '100%', height: '100%' }}/>;
    }

    return <MyMap/>;
}
